import type { ComponentType } from 'react';
import { appleMapsUrl, googleMapsUrl, wazeUrl, telUrl } from '@shared/maps';
import { AppleMapsIcon, GoogleMapsIcon, WazeIcon, PhoneIcon, GlobeIcon } from './Icons';

interface MapActionsProps {
  address: string;
  latitude: number;
  longitude: number;
  phone?: string | null;
  website?: string | null;
  extra?: { label: string; href: string; icon?: ComponentType }[];
}

export function MapActions({ address, latitude, longitude, phone, website, extra }: MapActionsProps) {
  return (
    <div className="action-row" role="group" aria-label="Get directions and contact">
      {phone && (
        <a className="action-btn" href={telUrl(phone)} aria-label={`Call ${phone}`}>
          <PhoneIcon />
          Call
        </a>
      )}
      {website && (
        <a className="action-btn" href={website} target="_blank" rel="noreferrer" aria-label="Open website">
          <GlobeIcon />
          Website
        </a>
      )}
      <a
        className="action-btn"
        href={appleMapsUrl(address)}
        target="_blank"
        rel="noreferrer"
        aria-label="Directions in Apple Maps"
      >
        <AppleMapsIcon />
        Apple Maps
      </a>
      <a
        className="action-btn"
        href={googleMapsUrl(address)}
        target="_blank"
        rel="noreferrer"
        aria-label="Directions in Google Maps"
      >
        <GoogleMapsIcon />
        Google Maps
      </a>
      <a
        className="action-btn"
        href={wazeUrl(latitude, longitude)}
        target="_blank"
        rel="noreferrer"
        aria-label="Directions in Waze"
      >
        <WazeIcon />
        Waze
      </a>
      {extra?.map(({ label, href, icon: Icon }) => (
        <a key={label} className="action-btn" href={href} target="_blank" rel="noreferrer" aria-label={label}>
          {Icon ? <Icon /> : null}
          {label}
        </a>
      ))}
    </div>
  );
}
